import { IoWarningOutline } from "react-icons/io5";
import { ZINDEX_LEVELS } from "../Helpers/Enums";

const CommonActionPopupModal = ({
  title,
  description,
  confirmButtonLabel,
  onCancel,
  OnConfirmed,
  disableCancelBtn,
  RejectionButtonLabel,
}) => {
  return (
    <div className="deleteActionModal">
      <div
        className="modal"
        style={{ display: "block", zIndex: ZINDEX_LEVELS.LEVEL_2 }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div
              className="modal-header "
              style={{
                flexDirection: "column",
                justifyContent: "center",
                backgroundColor: "unset",
                borderBottom: "none",
                color: "unset",
                padding: "unset",
                fontFamily: "unset",
              }}
            >
              <div
                style={{
                  fontSize: "3.8rem",
                  color: "#e17506",
                  backgroundColor: "#fef3c6",
                  padding: "1rem",
                  borderRadius: "100%",
                  display: "flex",
                  marginTop: "2rem",
                }}
              >
                <IoWarningOutline />
              </div>

              <h4 className="modal-title mt-3" style={{ fontSize: "3rem" }}>
                {title ?? "Alert"}
              </h4>
            </div>

            <div className="modal-body">
              <p className="fs-2" style={{ color: "#797989" }}>
                {description ?? "Are you sure?"}
              </p>
            </div>

            <div className="modal-footer">
              {!disableCancelBtn && (
                <button
                  type="button"
                  className="btn btn-light px-5 fs-3 rounded-4"
                  onClick={onCancel}
                  style={{ backgroundColor: "#eceef2" }}
                >
                  <span>{RejectionButtonLabel ?? "Cancel"}</span>
                </button>
              )}

              <button
                type="button"
                className="btn btn-danger px-5 fs-3 rounded-4"
                onClick={OnConfirmed}
              >
                <span>{confirmButtonLabel ?? "Yes"}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonActionPopupModal;
